// extracted by mini-css-extract-plugin
module.exports = {"list":"InfoMessageListTheme__list--3KOr6"};